import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getCovidPatientEvolutions () {
    return Api().get("/covid-patient-evolutions");
  },
  updateCovidPatientEvolution (params) {
    return Api().put("/covid-patient-evolutions",params);
  },
  addCovidPatientEvolution (params) {
    return Api().post("/covid-patient-evolutions",params);
  },
  getCovidPatientEvolution (params) {
    return Api().get("/covid-patient-evolutions/"+params);
  },
  getCovidPatientEvolutionByPatient (params) {
    return Api().get("/covid-patient-evolutions-by-patient/"+params);
  },
  deleteCovidPatientEvolution (params) {
    return Api().delete("/covid-patient-evolutions/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/CovidPatientEvolutionService.js